import React, { ElementType, FC, HTMLAttributes } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { controlArrowIconSizesPx, controlArrowIconSizesRem, controlArrowSizesPx, controlArrowSizesRem } from '@shared/config/components/controlArrowSizes';
import { ArrowLeft, ArrowRight } from '@shared/assets/icons';
type SizeValue = keyof typeof controlArrowSizesRem;
type ResponsiveSize = SizeValue | {
  mobile: SizeValue;
  desktop: SizeValue;
};
interface ControlArrowProps extends HTMLAttributes<HTMLButtonElement> {
  as?: ElementType;
  size?: ResponsiveSize;
  direction?: 'left' | 'right';
  onClick?: () => void;
}
const ControlArrow: FC<ControlArrowProps> = ({
  as = 'button',
  size = '40',
  direction = 'right',
  onClick,
  ...rest
}) => {
  const desktopSize = typeof size === 'object' ? size.desktop || '40' : size || '40';
  const mobileSize = typeof size === 'object' ? size.mobile || desktopSize : size || '40';
  return <ControlArrowWrapper as={as} desktopSize={desktopSize} mobileSize={mobileSize} onClick={onClick} {...rest}>
      <IconWrapper desktopSize={desktopSize} mobileSize={mobileSize}>
        {direction === 'left' ? <ArrowLeft /> : <ArrowRight />}
      </IconWrapper>
    </ControlArrowWrapper>;
};
export default ControlArrow;
type ControlArrowWrapperProps = {
  desktopSize: SizeValue;
  mobileSize: SizeValue;
};
const _exp2 = /*#__PURE__*/() => ({
  desktopSize
}) => controlArrowSizesRem[desktopSize];
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => `inset 0 0 0 9999px ${theme.colors.background.hover}`;
const _exp8 = /*#__PURE__*/() => ({
  mobileSize
}) => controlArrowSizesPx[mobileSize];
const ControlArrowWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "ControlArrowWrapper",
  class: "c1q9quqq",
  propsAsIs: false,
  vars: {
    "c1q9quqq-0": [_exp2()],
    "c1q9quqq-1": [_exp3()],
    "c1q9quqq-2": [_exp4()],
    "c1q9quqq-3": [_exp6()],
    "c1q9quqq-4": [_exp8()]
  }
}));
type IconWrapperPropsType = {
  desktopSize: SizeValue;
  mobileSize: SizeValue;
};
const _exp9 = /*#__PURE__*/() => ({
  desktopSize
}) => controlArrowIconSizesRem[desktopSize].width;
const _exp0 = /*#__PURE__*/() => ({
  desktopSize
}) => controlArrowIconSizesRem[desktopSize].height;
const _exp1 = /*#__PURE__*/() => ({
  mobileSize
}) => controlArrowIconSizesPx[mobileSize].width;
const _exp10 = /*#__PURE__*/() => ({
  mobileSize
}) => controlArrowIconSizesPx[mobileSize].height;
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i19v3eza",
  propsAsIs: false,
  vars: {
    "i19v3eza-0": [_exp9()],
    "i19v3eza-1": [_exp0()],
    "i19v3eza-2": [_exp1()],
    "i19v3eza-3": [_exp10()]
  }
});

require("./ControlArrow.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ControlArrow.tsx");